import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const BywayFavorite = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M5.31294 6.89768L1.43128 5.18014C1.09975 5.03283 0.709614 5.17685 0.559411 5.50198C0.409208 5.8271 0.556056 6.20971 0.887582 6.35702L4.27889 7.87102M1.62284 6.68534C1.29131 6.53804 0.887138 6.68871 0.736935 7.01384C0.586733 7.33897 0.733581 7.72158 1.06511 7.86889L4.21398 9.27517M2.04704 8.30764C1.71552 8.16033 1.30754 8.30896 1.15778 8.63393C1.00758 8.95905 1.15442 9.34167 1.48595 9.48897L5.11969 11.1107L5.55224 11.2828C7.03137 11.8713 8.72186 11.2251 9.40562 9.8106C9.53541 9.5423 9.61044 9.38938 9.7539 9.08597C10.1247 8.30223 9.86297 7.22596 9.17121 6.69544L9.15203 6.68083C8.29774 5.86568 7.7562 4.80837 7.48515 4.18467C7.35117 3.87619 6.99111 3.7266 6.66703 3.84624L6.66614 3.84656C6.31167 3.97741 6.14653 4.37363 6.30889 4.70367L7.07417 6.24832L2.70765 4.31534C2.37612 4.16803 1.98598 4.31205 1.83578 4.63717C1.68558 4.9623 1.83657 5.35965 2.1681 5.50696M5.82025 3.38611L3.06215 1.15768C2.78124 0.930062 2.36796 0.969227 2.139 1.24504C1.91004 1.52084 1.95158 1.92902 2.23249 2.15663L5.10438 4.49294M2.85207 2.66153C2.57116 2.43392 2.1451 2.4778 1.91614 2.7536C1.71561 2.99476 1.73221 3.36284 1.92524 3.59726M10.2837 6.73672C10.6172 6.07719 10.5679 5.19562 10.1221 4.61177L10.1077 4.59245C9.49703 3.58432 9.25097 2.42189 9.15205 1.74895C9.10334 1.41639 8.79554 1.17897 8.45213 1.21158L8.45125 1.2119C8.07562 1.24702 7.81349 1.58833 7.88398 1.94883L8.21931 3.63986L4.51618 0.648019C4.23527 0.420402 3.82199 0.459567 3.59303 0.735376C3.36407 1.01118 3.40392 1.43329 3.68466 1.66048" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline" viewBox="0 0 16 16" strokeWidth={1}>{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { BywayFavorite };